
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import { Optional } from "@/globalTypes";
import Loading from "@/components/Loading.vue";
import LoginButtons from "@/accounts/LoginButtons.vue";
import { sendGTMEvent } from "@/utils";

interface LoginViewData {
  email: string;
  password: string;
  emailError: Optional<String>;
  passwordError: Optional<String>;
  globalError: Optional<String>;
  isSending: boolean;
}

export default defineComponent({
  data(): LoginViewData {
    return {
      email: "",
      password: "",
      emailError: null,
      passwordError: null,
      globalError: null,
      isSending: false,
    };
  },
  methods: {
    ...mapActions("accounts", ["login"]),
    handleLogin() {
      this.isSending = true;
      this.login({ email: this.email, password: this.password }).then(
        ({ success, errors }) => {
          this.isSending = false;
          if (success) {
            sendGTMEvent(
              {
                event: "logowanie",
                "login-method": "email",
              },
              () => {
                this.$router.push({ name: "index" });
              }
            );
          } else {
            this.emailError = errors.email;
            this.passwordError = errors.password;
            this.globalError = errors.message;
          }
        }
      );
    },
  },
  components: { LoginButtons, Loading },
  hideCarHeader: true,
});
